import { Component, h, Host, getAssetPath } from '@stencil/core';

@Component({
  tag: 'chat-message-writing-component',
  styleUrl: 'chat-message-writing-module.scss',
  shadow: true,
})
export class ModuleChatMessageWriting {
  render() {
    return (
      <Host>
        <img
          src={getAssetPath('./../assets/icons/loader-chat.svg')}
          alt="Loader"
        />
      </Host>
    );
  }
}
